import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import { PageHeader } from '@/layouts/PageHeader.js';
import { NotesGridView } from '@/components/notes/NotesGridView.js';
import { SearchInput } from '@/components/common/SearchInput.js';
import { Button } from '@/components/ui/button.js';
import { useAppContext } from '@/contexts/AppContext.js';

export function NotesPage() {
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();
  const { notes, createNewNote } = useAppContext();

  const handleCreateNote = () => {
    createNewNote();
    // Note: createNewNote sets currentNote, we'll navigate based on that
    navigate('/notes/editor');
  };

  return (
    <>
      <PageHeader
        title="Notes"
        subtitle={`${notes.length} ${notes.length === 1 ? 'note' : 'notes'}`}
        actions={
          <>
            <SearchInput
              placeholder="Search notes..."
              value={searchQuery}
              onChange={setSearchQuery}
            />
            <Button onClick={handleCreateNote} className="gap-2">
              <Plus className="h-4 w-4" />
              New Note
            </Button>
          </>
        }
      />
      <main className="flex-1 overflow-hidden">
        <NotesGridView
          searchQuery={searchQuery}
        />
      </main>
    </>
  );
}
